import type { ComponentProps, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type QuestionPreviewBoxProps = ComponentProps<"div"> & {
	children: ReactNode;
	withTopSpacing?: boolean;
};

export function QuestionPreviewBox({
	children,
	className,
	withTopSpacing = false,
	...props
}: QuestionPreviewBoxProps) {
	return (
		<div
			className={twMerge(
				"rounded-lg border border-gray-200 bg-white p-4",
				withTopSpacing ? "mt-6" : undefined,
				className
			)}
			data-slot="question-preview-box"
			{...props}
		>
			<h4 className="mb-3 font-semibold text-gray-700 text-sm">Preview</h4>
			{children}
		</div>
	);
}
